(function () {

    'use strict';

    angular.module('iplusjs.filter.yesNo', [
        'iplusjs.utils.format'
    ])
    .filter('yesNo', YesNo);

    YesNo.$inject = [
        'FormatUtilsService'
    ];
    function YesNo(FormatUtilsService) {
        return function (boolean) {
            return FormatUtilsService.booleanToYesNo(boolean);
        };
    }
})();
